"use client";

import { useRef, useState, useEffect, memo } from "react";

import { NavbarLink } from "./navbar-link";
import { NavbarMenu } from "./navbar-menu";
import { NavbarMenuItem } from "./navbar-menu-item";
import { NavbarProvider } from "./navbar.context";
import { NavbarPortal } from "./navbar-portal";
import { navbarNavStyles, navbarStyles } from "./styles/navbar.styles";

import type { NavbarProps } from "./types/navbar.types";

interface NavbarComponents {
  Link: typeof NavbarLink;
  Menu: typeof NavbarMenu;
  MenuItem: typeof NavbarMenuItem;
}

const NavbarComponent: React.FC<NavbarProps> = memo((props) => {
  const { children, className, onValueChange, ...rest } = props;

  const [mounted, setMounted] = useState(false);

  const portalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <NavbarProvider onValueChange={onValueChange} portalRef={portalRef} mounted={mounted}>
      <nav className={navbarNavStyles()} {...rest}>
        <ul className={navbarStyles({ className })}>{children}</ul>

        <NavbarPortal ref={portalRef} />
      </nav>
    </NavbarProvider>
  );
});

NavbarComponent.displayName = "Navbar";

export const Navbar = NavbarComponent as React.FC<NavbarProps> & NavbarComponents;

Navbar.Link = NavbarLink;
Navbar.Menu = NavbarMenu;
Navbar.MenuItem = NavbarMenuItem;
